import { getCurrencyProps } from './get-currency-props';

export function formatCurrency(locale: string, value?: number, checkoutMode?: boolean) {
  if (value === undefined) {
    return '';
  }

  const checkoutProps = getCurrencyProps();
  const currency = checkoutMode ? checkoutProps.checkoutCurrency : checkoutProps.currency;
  const adjustedValue = checkoutMode ? value : value * checkoutProps.multiplicator;

  return formatCurrencyWithSymbol({ locale, value: adjustedValue, currency });
}

export function formatCurrencyWithSymbol({
  locale,
  value,
  currency,
}: {
  locale: string;
  value: number;
  currency: string;
}) {
  const supportedCurrencies = Intl.supportedValuesOf('currency');

  if (supportedCurrencies.includes(currency)) {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      maximumFractionDigits: 4,
      currency,
    }).format(value);
  } else {
    return `${value.toLocaleString('en-AT', {
      maximumFractionDigits: 2,
    })} ${currency}`;
  }
}
